import React from 'react';
import { StyledCardWrapper, StyledCloudImage, StyledContentWrapper, StyledTextPairing } from './CheckOutExperienceCard.styles';
import { registryPageData } from '@data-ts/pages/registry';
import { CloudImage } from '@components/CloudImage';

const {
  guestExperienceSection: { checkOutExperienceCard },
} = registryPageData;

export const CheckOutExperienceCard = () => {
  return (
    <StyledCardWrapper>
      <StyledCloudImage
        alt="wedding-registry-seamless-checkout"
        optimization="none"
        src={'registry-q12024/better-for-guests/hero-seamlesscheckout@2x.png'}
      />

      <StyledContentWrapper>
        <StyledTextPairing
          titleVariant="calloutHed40"
          titleColor="white"
          titleTagName="h3"
          title={checkOutExperienceCard.title}
          body={checkOutExperienceCard.body}
          bodyVariant="dek20"
          bodyColor="white"
          bodyMaxWidth="480px"
          textAlign="center"
        />
      </StyledContentWrapper>
    </StyledCardWrapper>
  );
};
